// import { flipManager } from "./mask-flipanim-manager.js";

export class ScrChecker {
  constructor() {
    this.inviewElems = []; //inviewで効果をつける要素を登録する

    //flipanim(mask))
    this.flipMaskElems = {};
    this.flipMaskManager = {};

    // flipanim s
    this.flipMaskGroup = {}; //sサイズ,ループ, inviewで再生開始
    this.flipMaskGroupElems = {};

    //flipanimの準備ができたかどうか + flipanimする要素が1以上ある
    this.underFirstviewReady = false;

    //requestAnimationFrameの実行フラグ
    this.ticking = false;
  }
  setProps(el, props) {
    for (let key in props) {
      el.style.setProperty("--" + key, props[key]);
    }
  }
  clamp(v, min, max) {
    return min > v ? min : max < v ? max : v;
  }
  round(n) {
    return Math.round(n * 10000) / 10000;
  }

  calcElementOffsetY(elem) {
    let container = window;

    let parentElem;
    if (elem.parentElement) {
      parentElem = elem.parentElement;
    }
    let target = parentElem;

    // ページ全体に対するY座標を計算
    let numY = 0;
    do {
      numY += target.offsetTop; //target.offsetTop;はノードの上端に対しての現在の要素の距離
      target = target.offsetParent;
      //console.log(target);
    } while (target && target !== container); //要素のcontainerに対するY座標

    return numY;
  }

  onUpdate() {
    //console.log("scrChecker onUpdate");
    this.inviewElems = document.querySelectorAll(".js-inview");

    //ウインドウ情報 ie11未対応
    let windowWidth = window.innerWidth;
    let windowHeight = window.innerHeight;
    let windowOffsetY = window.scrollY;
    let windowScrollY = window.scrollY;
    let windowScrollX = window.scrollX;

    //console.log(windowScrollY);
    this.body = document.getElementsByTagName("body")[0];
    this.html = document.getElementsByTagName("html")[0];

    if (windowScrollY > windowHeight) {
      this.body.classList.add("scrolled-windowheight");
    } else {
      this.body.classList.remove("scrolled-windowheight");
    }

    // if (windowScrollY > 3 * windowHeight) {
    //   this.body.classList.add("scrolled-windowheight-x3");
    // } else {
    //   this.body.classList.remove("scrolled-windowheight-x3");
    // }

    //scroller
    if (document.getElementById("index__scroller--lp")) {
      let checkpoint = windowHeight;
      let detectedClass = "index__scroller--none";

      //check
      if (document.getElementById("index-about").getBoundingClientRect().top <= -50) {
        detectedClass = "index__scroller--about";
      }
      if (document.getElementById("index__scroller--lp").getBoundingClientRect().top <= checkpoint) {
        detectedClass = "index__scroller--lp";
        document.getElementById("index-main-lp").querySelector(".common-cover__feature-link").classList.add("inview");
      }
      if (document.getElementById("index__scroller--tg").getBoundingClientRect().top <= checkpoint) {
        detectedClass = "index__scroller--tg";
        document.getElementById("index-main-tg").querySelector(".common-cover__feature-link").classList.add("inview");
      }
      if (document.getElementById("index__scroller--sd").getBoundingClientRect().top <= checkpoint) {
        this.body.classList.add("scrolled3");
        detectedClass = "index__scroller--sd";
        document.getElementById("index-main-sd").querySelector(".common-cover__feature-link").classList.add("inview");
      } else {
        this.body.classList.remove("scrolled3");
      }
      if (document.getElementById("index__scroller--contact").getBoundingClientRect().top <= checkpoint) {
        detectedClass = "index__scroller--contact";
      }
      //   if (document.getElementById("footer").getBoundingClientRect().top <= checkpoint) {
      //     detectedClass = "index__scroller--footer";
      //   }

      //console.log(document.getElementById("footer").getBoundingClientRect().top);

      //classをbodyから削除 ("index__scroller--lp","index__scroller--tg","index__scroller--sd","index__scroller--contact"のうちdetectedClassの値と同じでない場合)
      let checkClasses = [
        "index__scroller--about",
        "index__scroller--lp",
        "index__scroller--tg",
        "index__scroller--sd",
        "index__scroller--contact",
        "index__scroller--footer",
      ];
      let targetElem = ["index-about", "index-main-lp", "index-main-tg", "index-main-sd", "lp-contact", "footer"];
      checkClasses.forEach((checkClass, index) => {
        if (checkClass !== detectedClass) {
          this.body.classList.remove(checkClass);
          //console.log(targetElem[index]);

          if (document.getElementById(targetElem[index]).querySelector(".js-scrolled")) {
            document.getElementById(targetElem[index]).querySelector(".js-scrolled").classList.remove("inview");
          }
        } else {
          this.body.classList.add(detectedClass);
          if (document.getElementById(targetElem[index]).querySelector(".js-scrolled")) {
            document.getElementById(targetElem[index]).querySelector(".js-scrolled").classList.add("inview");
          }
        }
      });
    }

    // if (windowScrollY > windowHeight * 0.8) {
    //   this.body.classList.add("scrolled-show-index-pager");
    // } else {
    //   this.body.classList.remove("scrolled-show-index-pager");
    // }

    if (this.body.classList.contains("loaded")) {
      //console.log(windowScrollY);
      //   if (windowScrollY > 200) {
      //     this.body.classList.add("scrolled-title");
      //   } else {
      //     this.body.classList.remove("scrolled-title");
      //   }
      if (windowScrollY > 0) {
        this.body.classList.add("scrolled");
      } else {
        this.body.classList.remove("scrolled");
      }

      if (windowScrollY > 30) {
        this.body.classList.add("scrolled2");
      } else {
        this.body.classList.remove("scrolled2");
      }
    }

    // ===========
    // スクロール方向によりメニューを状態変更);
    if (this.thenPosition <= document.documentElement.scrollTop && windowScrollY > 0) {
      //下へスクロール
      //console.log("scroll down", this.thenPosition - document.documentElement.scrollTop);
      //   this.body.classList.remove("show-menu");
      //   this.body.classList.remove("show-menu-bg");

      if (this.body.classList.contains("index")) {
        //トップページ
        if (windowScrollY > 30) {
          this.body.classList.remove("show-menu");
        }
      } else {
        if (windowScrollY < 30 && this.body.classList.contains("os-ios")) {
          if (this.body.classList.contains("op-finished2")) {
            this.body.classList.add("show-menu");
          }
        } else {
          this.body.classList.remove("show-menu");
        }
      }
    } else {
      //上へスクロール
      //console.log("scroll up", this.thenPosition - document.documentElement.scrollTop);
      //console.log(this.body);

      if (this.body.classList.contains("op-finished2")) {
        this.body.classList.add("show-menu");
      }

      if (this.body.classList.contains("index")) {
        //トップページ
        // if (this.body.classList.contains("scrolled-windowheight")) {
        //   this.body.classList.add("show-menu-bg");
        // } else {
        //   this.body.classList.remove("show-menu-bg");
        // }
      } else {
        //中ページはヘッダの高さを見る？
        if (document.querySelectorAll(".js-sub-header")[0] && document.getElementById("menu")) {
          let subHeaderheight = document.querySelectorAll(".js-sub-header")[0].clientHeight;
          let menuHeight = document.getElementById("menu").clientHeight;
          if (subHeaderheight - menuHeight < windowScrollY) {
            this.body.classList.add("show-menu-bg");
          } else {
            this.body.classList.remove("show-menu-bg");
          }
        }
      }
    }

    //オープニング中はメニューを表示しない
    // if (!this.body.classList.contains("op-finished2")) {
    //   if (this.body.classList.contains("sitepolicy")) {
    //     this.body.classList.add("show-menu");
    //   } else {
    //     this.body.classList.remove("show-menu");
    //   }
    // }

    //スムーズスクロール時はメニューを表示しない
    if (this.body.classList.contains("is-scrolling")) {
      this.body.classList.remove("show-menu");
    }

    this.thenPosition = document.documentElement.scrollTop;

    // ===========
    // inview判定 - .js-inview に .inview 追加
    if (this.inviewElems.length !== 0) {
      let exeFlg = false;

      //body.indexの場合は、body.op-finishedの時だけ実行
      if (this.body.classList.contains("index")) {
        if (this.body.classList.contains("op-finished")) {
          exeFlg = true;
        }
      } else {
        exeFlg = true;
      }

      if (exeFlg) {
        //inviewElems = document.querySelectorAll('.js-inview');//複数
        [].forEach.call(this.inviewElems, (elem) => {
          //console.log(elem.classList);
          let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
          let y = clientRect.top; //画面の上端から、要素の上端までの距離
          //let elemY = window.pageYOffset + clientRect.top;// ページの上端から、要素の上端までの距離

          //表示タイミング ウインドウ上端から
          let showPos = windowHeight * 0.6;
          if (windowWidth > 600) {
            showPos = windowHeight * 0.7; //pc
          }

          //表示タイミング(delay) ウインドウ上端から
          if (elem.classList.contains("js-inview-delay")) {
            showPos = windowHeight * 0.6;
            if (windowWidth > 600) {
              showPos = windowHeight * 0.6; //pc
            }
          }
          //表示タイミング(delay2) ウインドウ上端から
          if (elem.classList.contains("js-inview-delay2")) {
            showPos = windowHeight * 0.5;
            if (windowWidth > 600) {
              showPos = windowHeight * 0.4; //pc
            }
          }

          if (showPos > y) {
            elem.classList.add("inview");
          }
        });
      }
    }

    // ===========
    // js-inview-flip判定　小さいflipanim(イントロのあるもの)はinviewで再生開始
    // if (this.underFirstviewReady) {
    //   for (let key in this.flipMaskGroup) {
    //     const elem = document.getElementById(key);
    //     const flipMaskElems = this.flipMaskGroupElems[key];

    //     //console.log(elem);
    //     const clientRect = elem.getBoundingClientRect(); // 要素の位置座標

    //     const y = clientRect.top; //画面の上端から、要素の上端までの距離
    //     //const elemY = window.pageYOffset + clientRect.top; // ページの上端から、要素の上端までの距離
    //     //表示タイミング ウインドウ上端から
    //     let showPos = windowHeight * 0.6;
    //     if (windowWidth > 600) {
    //       showPos = windowHeight * 0.7; //pc
    //     }
    //     if (
    //       showPos > y &&
    //       !elem.classList.contains("inview-flipanim-started")
    //     ) {
    //       elem.classList.add("inview-flipanim-started");
    //       //console.log("js-inview-flip #", key);
    //       this.flipMaskGroup[key].start(flipMaskElems);
    //     }
    //   }
    // }

    this.updateClipPath();
  }

  updateClipPath() {
    // ===========
    // index-abouy SPでテキストにマスクする --masky
    if (document.querySelectorAll(".js-mask-y")[0]) {
      //let windowWidth = window.innerWidth || document.documentElement.clientWidth || 0;

      let targetElem = document.querySelectorAll(".js-mask-y")[0];
      //let targetElemHeight = targetElem.clientHeight;
      let targetElemTop = targetElem.getBoundingClientRect().top;
      //let maskHeight = windowWidth * 1.7; //cssで指定
      let circleTop = document.querySelectorAll(".index-cover__circle")[0].getBoundingClientRect().top;
      let circleWidth = document.querySelectorAll(".index-cover__circle")[0].clientWidth;

      let adjustY = circleTop - targetElemTop;

      //console.log(targetElem, circleWidth, circleTop, targetElemTop, adjustY);

      let props = {
        masky: adjustY,
      };
      this.setProps(targetElem, props);
    }
  }

  // 初期化
  init() {
    this.inviewElems = document.querySelectorAll(".js-inview");
  }

  // FV以下のコンテンツload後の初期化
  initAfterLoaded() {
    this.underFirstviewReady = true;
    //console.log("initAfterLoaded");

    //大きいflipanim(ループするもの)
    // if (document.querySelectorAll(".js-mask-flipanim")[0]) {
    //   this.flipMaskElems = document.querySelectorAll(".js-mask-flipanim");
    //   if (this.flipMaskElems.length !== 0) {
    //     this.flipMaskManager = new flipManager();
    //     this.flipMaskManager.init(this.flipMaskElems);
    //     this.flipMaskManager.start(this.flipMaskElems);
    //   }
    // }

    //大きいflipanim(maskでない・ループするもの)
    // if (document.querySelectorAll(".js-sprite-anim")[0]) {
    // }

    //小さいflipanim(イントロのあるもの)
    // if (document.querySelectorAll(".js-inview-flip")[0]) {
    //   const group = document.querySelectorAll(".js-inview-flip");
    //   [].forEach.call(group, (elem) => {
    //     this.flipMaskGroupElems[elem.id] = elem.querySelectorAll(
    //       ".js-mask-flipanim-s"
    //     );
    //     //console.log(elem.id, this.flipMaskGroupElems[elem.id]);
    //     this.flipMaskGroup[elem.id] = new flipManager();
    //     this.flipMaskGroup[elem.id].init(this.flipMaskGroupElems[elem.id]);
    //     //this.flipMaskGroup[elem.id].start(this.flipMaskGroupElems[elem.id]); //inviewしたら再生
    //   });
    // }
  }
}
